var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-477.000000, -221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(478.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    stroke: "#2359A3",
    strokeWidth: 1.5,
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 8.000000)",
    fill: "#2359A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.08457895,9.94736842 C4.82697158,9.94736842 4.56937895,9.83655474 4.38516842,9.65234421 L0.626168421,5.89481789 C0.257747368,5.52639684 0.184357895,4.90037579 0.515354737,4.53195474 C0.883775789,4.09014421 1.54722842,4.05271263 1.95160737,4.45855789 L5.08318632,7.59013684 L5.12060316,7.59013684 L12.0830242,0.627715789 C12.4514453,0.259294737 13.0415084,0.185905263 13.4458874,0.516902105 C13.8876979,0.885323158 13.9251295,1.54877579 13.5192842,1.95315474 L5.78244211,9.68999684 C5.59967211,9.87420737 5.34206842,9.94760421 5.08446842,9.94760421 L5.08457895,9.94736842 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkBlue);
export default __webpack_public_path__ + "static/media/checkmark-blue.6cc5642d2790328615cc552828b2a6b8.svg";
export { ForwardRef as ReactComponent };